import Openable from './lib/openable';

class Drawer extends Openable {
  constructor(element) {
    super(element);
    this.classes = {
      active: 'drawer--active',
    };
  }
}

export default (element) => new Drawer(element);
